import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledSuccessBannerWrapper = styled(Stack)`
    justify-content: center;
    width: 100%;
    min-height: 144px;
    row-gap: 12px;
    align-items: center;
    background-color: ${colorsPalettes.bluegrey[100]};
    border-radius: 8px;
    padding: 10px 12px 12px;
`;

export const SuccessContentWrapper = styled(Stack)`
    row-gap: 4px;
    margin-top: -80px;
    align-items: center;
`;

export const StyledIcon = styled(SWReactIcons)`
    width: 180px;
    height: 170px;
    margin-top: -16px;
`;
